<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col
          cols="12"
          md="7"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon"
            @click="$router.go(-1)"
          >
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col" v-if="pillarTitleId">Pillar Title Edit</th>
              <th scope="col" v-else>Pillar Title Add</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="pillarTitleRules">
        <b-form>
          <b-row>
            <b-col cols="6" md="12" sm="12">
              <b-form-group label="Pillar Title" label-for="title">
                <validation-provider
                  name="title"
                  #default="{ errors }"
                  rules="required"
                >
                  <textarea
                    v-model="pillarTitleValue.title"
                    class="form-control"
                    id="title"
                    name="title"
                    rows="3"
                    placeholder="Enter Pillar Title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6" md="12" sm="12">
              <b-form-group label="Pillar" label-for="pillar">
                <validation-provider
                  name="pillar"
                  #default="{ errors }"
                  rules="required"
                >
                  <v-select
                    v-model="pillarTitleValue.pillar_id"
                    label="title"
                    :reduce="(val) => val.id"
                    :options="pillars"
                    :appendToBody="true"
                    :clearable="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button
                v-if="pillarTitleId == null"
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                Save
              </b-button>
              <b-button
                v-else
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                Save Changes
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    vSelect,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },

  setup() {
    const OBJECT_CODE_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
      store.registerModule(
        OBJECT_CODE_APP_STORE_MODULE_NAME,
        settingsStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
        store.unregisterModule(OBJECT_CODE_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      pillarTitleValue: {
        title: "",
        pillar_id: "",
        required,
        email,
      },
      pillars: [],
      formShow: false,
      pillarTitleId: null,
    };
  },

  watch: {},

  mounted() {
    this.getPillarTitleById();
    this.getPillars();
  },

  methods: {
    getPillars() {
      store
        .dispatch("settings/getAllPillars")
        .then((res) => {
          this.pillars = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "An error occurred",
              text: "Please try again later or contact support.",
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
        });
    },

    getPillarTitleById() {
      if (router.currentRoute.params.id) {
        this.formShow = true;
        this.pillarTitleId = parseInt(router.currentRoute.params.id);

        store
          .dispatch("settings/getPillarTitleById", {
            id: router.currentRoute.params.id,
          })
          .then((res) => {
            this.pillarTitleValue = res.data;
            this.formShow = false;
          })
          .catch((error) => {
            console.log(error);
            this.formShow = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "An error occurred",
                text: "Please try again later or contact support.",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    formSubmitted() {
      this.formShow = true;

      this.$refs.pillarTitleRules.validate().then((success) => {
        if (success) {
          if (this.pillarTitleId == null) {
            store
              .dispatch("settings/savePillarTitle", this.pillarTitleValue)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Pillar Title Add Successful",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-pillar-titles" });
              })
              .catch((error) => {
                this.formShow = false;
                console.log(error);
                const errorMessage =
                  error.response?.data?.errors?.title?.[0] ||
                  "An error occurred while saving the pillar title.";
                this.handleError(errorMessage);
              });
          } else {
            store
              .dispatch("settings/updatePillarTitle", this.pillarTitleValue)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Pillar Title Update Successful",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-pillar-titles" });
              })
              .catch((error) => {
                this.formShow = false;
                console.log(error);
                const errorMessage =
                  error.response?.data?.errors?.title?.[0] ||
                  "An error occurred while saving the pillar title.";
                this.handleError(errorMessage);
              });
          }
        } else {
          this.formShow = false;
        }
      });
    },

    handleError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
      this.formShow = false;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

// .v-select .vs__dropdown-menu {
//   top: auto !important;
//   bottom: calc(100% + 4px);
// }
</style>
